// extracted by mini-css-extract-plugin
export default {"button":"RequestNewCourse_button__Yd96u","icon":"RequestNewCourse_icon__UdXkR"};